import React from 'react'
import { useState, useEffect } from 'react';
import FacebookIcon from '../images/facebook.webp'
import InstagramIcon from '../images/instagram.webp'
import TikTokIcon from '../images/tiktok.png'
import LinkedinIcon from '../images/linkedin.webp'
import WhiteLogo from '../images/logo-blanco.webp'
import youtubeIcon from '../images/youtube.webp'
import camaraComercio from '../images/logo-css-footer.webp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';

function Footer() {

    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    const toggleVisibility = () => {
        if (window.pageYOffset > 800) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

  return (
    <>
        <div className={`scrollToTop ${isVisible ? 'showScrollToTop' : ''}`} onClick={scrollToTop}>
            <FontAwesomeIcon icon={faChevronUp} />
        </div>
        <footer className="Footer">
            <div className="container">
                <div className="Footer__container">
                    <div className="Footer__left">
                        <div className="Footer__left--heading">
                            <div className="Footer__left--heading-logo">
                                <img src={WhiteLogo} alt="logo-recibelo-blanco" width="190" height="91" />
                            </div>
                            <div className="Footer__left--heading-text">
                                <h4>Cuando mañana es muy tarde,</h4>
                                <p>somos tu solución logística.</p>
                            </div>
                        </div>
                        <div className="Footer__left--followUs mobileFollowUs">
                            <div className="Footer__left--followUs-text">
                                <p>Síguenos en nuestras redes</p>
                            </div>
                            <div className="Footer__left--followUs-social">
                                <ul>
                                    <li><a href="https://www.instagram.com/recibelo.cl/" target="_blank"><img src={InstagramIcon} alt="instagram-logo" width="40px" height="40px" /></a></li>
                                    <li><a href="https://www.tiktok.com/@recibelo.cl" target="_blank"><img src={TikTokIcon} alt="tiktok-logo" width="40px" height="40px" /></a></li>
                                    <li><a href="https://web.facebook.com/recibelocl" target="_blank"><img src={FacebookIcon} alt="facebook-logo" width="40px" height="40px" /></a></li>
                                    <li><a href="https://www.youtube.com/channel/UCbrOUkbT1JCWatCt5jx7WZw" target="_blank"><img src={youtubeIcon} alt="youtube-logo" width="40px" height="40px" /></a></li>
                                    <li><a href="https://www.linkedin.com/company/recibelo" target="_blank"><img src={LinkedinIcon} alt="linkedin-logo" width="40px" height="40px" /></a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="Footer__commerceLogo" id="mobileCSSLogo">
                            <img src={camaraComercio} alt="camara-comercio-logo" width="270" height="153" />
                        </div>
                    </div>
                    <div className="Footer__commerceLogo" id="desktopCSSLogo">
                        <img src={camaraComercio} alt="camara-comercio-logo" width="270" height="153" />
                    </div>
                    <div className="Footer__left--followUs desktopFollowUs">
                        <div className="Footer__left--followUs-text">
                            <p>Síguenos en nuestras redes</p>
                        </div>
                        <div className="Footer__left--followUs-social">
                            <ul>
                                <li><a href="https://www.instagram.com/recibelo.cl/" target="_blank"><img src={InstagramIcon} alt="instagram-logo" width="40px" height="40px" /></a></li>
                                <li><a href="https://www.tiktok.com/@recibelo.cl" target="_blank"><img src={TikTokIcon} alt="tiktok-logo" width="40px" height="40px" /></a></li>
                                <li><a href="https://web.facebook.com/recibelocl" target="_blank"><img src={FacebookIcon} alt="facebook-logo" width="40px" height="40px" /></a></li>
                                <li><a href="https://www.youtube.com/channel/UCbrOUkbT1JCWatCt5jx7WZw" target="_blank"><img src={youtubeIcon} alt="youtube-logo" width="40px" height="40px" /></a></li>
                                <li><a href="https://www.linkedin.com/company/recibelo" target="_blank"><img src={LinkedinIcon} alt="linkedin-logo" width="40px" height="40px" /></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="Footer__right">
                        <div className="Footer__right--contactUs">
                            <div className="Footer__right--contactUs-title">
                                <h2>Contacto</h2>
                            </div>
                        </div>
                        <div className="Footer__right--customerSupport">
                            <div className="Footer__right--customerSupport-title">
                                <h2>Atención al Cliente</h2>
                            </div>
                            <div className="Footer__right--customerSupport-text">
                                <a href="mailto:ayuda@recibelo.cl">ayuda@recibelo.cl</a>
                            </div>
                        </div>
                        <div className="Footer__right--hireUs">
                            <div className="Footer__right--hireUs-title">
                                <h2>Quiero contratarlos</h2>
                            </div>
                            <div className="Footer__right--hireUs-text">
                                <a href="mailto:hola@recibelo.cl">hola@recibelo.cl</a>
                            </div>
                        </div>
                        <div className="Footer__right--phone">
                            <a href="https://wa.me/56971037950" target="_blank" rel="noopener noreferrer">+56971037950</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </>
  )
}

export { Footer }